/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetEquipmentDashboardQueryResponse, GetEquipmentDashboardPathParams, GetEquipmentDashboardQueryParams, GetEquipmentDashboard400, GetEquipmentDashboard401, GetEquipmentDashboard403, GetEquipmentDashboard404, GetEquipmentDashboard409, GetEquipmentDashboard500 } from "../../types/equipmentController/GetEquipmentDashboard.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetEquipmentDashboardUrl(organizationId: GetEquipmentDashboardPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/equipment/dashboard` as const }
  return res
}

/**
 * @summary Get equipment dashboard data
 * {@link /api/organizations/:organizationId/equipment/dashboard}
 */
export async function getEquipmentDashboard(organizationId: GetEquipmentDashboardPathParams["organizationId"], params?: GetEquipmentDashboardQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetEquipmentDashboardQueryResponse, ResponseErrorConfig<GetEquipmentDashboard400 | GetEquipmentDashboard401 | GetEquipmentDashboard403 | GetEquipmentDashboard404 | GetEquipmentDashboard409 | GetEquipmentDashboard500>, unknown>({ method : "GET", url : getGetEquipmentDashboardUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}